import { z } from 'zod';
import { toolStatusEnum, kitItemTypeEnum } from './enums.ts';

export const createToolInput = z.object({
  name: z.string().min(1).max(120),
  category: z.string().min(1).max(64),
  brand: z.string().max(64).nullable().optional(),
  model: z.string().max(64).nullable().optional(),
  serialNumber: z.string().max(128).nullable().optional(),
  purchaseDate: z.string().nullable().optional(),
  storageZoneId: z.string().nullable().optional(),
  status: toolStatusEnum.optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export type CreateToolInput = z.infer<typeof createToolInput>;
export const patchToolInput = createToolInput.partial();
export type PatchToolInput = z.infer<typeof patchToolInput>;

export const createConsumableInput = z.object({
  name: z.string().min(1).max(120),
  category: z.string().min(1).max(64),
  quantity: z.number().int().nonnegative().nullable().optional(),
  unit: z.string().max(32).nullable().optional(),
  minimumQuantity: z.number().int().nonnegative().nullable().optional(),
  expirationDate: z.string().nullable().optional(),
  storageZoneId: z.string().nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export type CreateConsumableInput = z.infer<typeof createConsumableInput>;
export const patchConsumableInput = createConsumableInput.partial();
export type PatchConsumableInput = z.infer<typeof patchConsumableInput>;

export const createKitInput = z.object({
  name: z.string().min(1).max(120),
  slug: z
    .string()
    .min(1)
    .max(120)
    .regex(/^[a-z0-9-]+$/, 'slug must be kebab-case lowercase'),
  description: z.string().max(2000).nullable().optional(),
  domainId: z.string().nullable().optional(),
});
export type CreateKitInput = z.infer<typeof createKitInput>;

export const addKitItemInput = z.object({
  itemType: kitItemTypeEnum,
  itemId: z.string().min(1),
  quantity: z.number().int().nonnegative().nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export type AddKitItemInput = z.infer<typeof addKitItemInput>;
